import Button from 'components/base/Button';
import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { ContactInfo } from './contact.type';
import { updateRecruiter } from 'reducers/AuthReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

const validationSchema = Yup.object().shape({
  recruiterName: Yup.string().required('Recruiter name is required'),
  recruiterDesignation: Yup.string().required(
    'Recruiter designation is required'
  ),
  contactEmail: Yup.string()
    .email('Invalid email format')
    .required('Contact email is required'),
  contactPhoneNumber: Yup.string()
    .required('Contact phone number is required')
    .matches(
      /^\+?[1-9]\d{1,14}$/,
      'Phone number must include a country code and be valid'
    ) // E.164 format
});

function Contact() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    recruiterName,
    recruiterDesignation,
    contactEmail,
    contactPhoneNumber
  } = useSelector((state: RootState) => state.auth.register.recruiter);

  const handleBack = () => {
    navigate('/register/recruiter/basic');
  };

  const handleSubmit = (values: ContactInfo) => {
    dispatch(updateRecruiter(values));
    navigate('/register/recruiter/verify');
  };

  return (
    <>
      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Recruiter Information</div>
      </div>
      <Formik
        initialValues={{
          recruiterName: recruiterName || '',
          recruiterDesignation: recruiterDesignation || '',
          contactEmail: contactEmail || '',
          contactPhoneNumber: contactPhoneNumber || ''
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        <Form>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="recruiterName">Name</FormLabel>
            <Input
              name="recruiterName"
              id="recruiterName"
              placeholder="Ex: John"
            />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="contactEmail">Email address</FormLabel>
            <Input
              name="contactEmail"
              id="contactEmail"
              type="email"
              placeholder="name@example.com"
            />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="recruiterDesignation">Designation</FormLabel>
            <Input name="recruiterDesignation" id="recruiterDesignation" />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="contactPhoneNumber">Phone Number</FormLabel>
            <Input name="contactPhoneNumber" id="contactPhoneNumber" />
          </FormGroup>
          <Row className="g-3">
            <Col sm={6}>
              <Button
                variant="outline-primary"
                type="button"
                className="w-100 mb-3"
                onClick={handleBack}
              >
                Prev
              </Button>
            </Col>
            <Col sm={6}>
              <Button variant="primary" type="submit" className="w-100 mb-3">
                Next
              </Button>
            </Col>
          </Row>
        </Form>
      </Formik>
    </>
  );
}

export default Contact;
